<div class="meeting-row">
  <div class="meeting-row__top">
    @if (entry.consultantId && entry.photoId) {
      <img class="meeting-row__avatar meeting-row__avatar--photo"
           [lazyImage]="entry.consultantId" [lazyImagePhotoId]="entry.photoId"
           [alt]="entry.fullName"/>
    } @else {
      <span class="meeting-row__avatar">{{ getInitials(entry.fullName) }}</span>
    }
    <div class="meeting-row__id">
      <div class="meeting-row__name">
        {{ entry.fullName }}
        @if (entry.abbreviation) {
          <span class="meeting-row__kuerzel">{{ entry.abbreviation }}</span>
        }
      </div>
      <div class="meeting-row__pos">{{ entry.position || ('meetingMode.positionOpen' | translate) }}</div>
    </div>
    <div class="meeting-row__meta">
      @if (openOffersCount > 0) {
        <span class="meeting-row__offen" [matTooltip]="'meetingMode.openOffersTip' | translate">
          {{ 'meetingMode.openOffers' | translate: {count: openOffersCount} }}
        </span>
      }
      <span class="meeting-row__ang" [matTooltip]="'meetingMode.totalOffersTip' | translate">
        {{ 'meetingMode.totalOffers' | translate: {count: totalOffers} }}
      </span>
    </div>
  </div>

  <div class="meeting-row__controls">
    <label class="meeting-row__field">
      <span class="meeting-row__field-head">
        <span class="meeting-row__label">{{ 'meetingMode.field.availableFrom' | translate }}</span>
        <span class="meeting-row__field-saved" aria-live="polite">
          @if (savedField === 'availableFrom') {
            <mat-icon>check</mat-icon>{{ 'meetingMode.field.savedHint' | translate }}
          }
        </span>
      </span>
      <div class="meeting-row__date" (click)="dp.open()">
        <input class="meeting-row__date-input" [matDatepicker]="dp" placeholder="TT.MM.JJJJ" readonly
               [ngModel]="toMoment(entry.availableFrom)" (ngModelChange)="onDateChange($event)">
        @if (entry.availableFrom) {
          <button type="button" class="meeting-row__date-clear"
                  (click)="$event.stopPropagation(); clearDate()">
            <mat-icon>close</mat-icon>
          </button>
        }
        <mat-datepicker #dp></mat-datepicker>
      </div>
    </label>

    <label class="meeting-row__field meeting-row__field--grow">
      <span class="meeting-row__field-head">
        <span class="meeting-row__label">{{ 'meetingMode.field.nextStep' | translate }}</span>
        <span class="meeting-row__field-saved" aria-live="polite">
          @if (savedField === 'nextStep') {
            <mat-icon>check</mat-icon>{{ 'meetingMode.field.savedHint' | translate }}
          }
        </span>
      </span>
      <input class="meeting-row__input" [(ngModel)]="entry.nextStep" (change)="saveInline('nextStep')"
             [maxlength]="LIMITS.FREETEXT"
             [placeholder]="'meetingMode.field.nextStepPlaceholder' | translate">
    </label>
  </div>

  <label class="meeting-row__stand">
    <span class="meeting-row__label">{{ 'meetingMode.note.label' | translate }}</span>
    <textarea class="meeting-row__input meeting-row__stand-area" rows="2" [(ngModel)]="standDraft"
              [maxlength]="LIMITS.FREETEXT"
              [placeholder]="'meetingMode.note.placeholder' | translate"></textarea>
    <div class="meeting-row__save-row">
      @if (showSaved) {
        <span class="meeting-row__saved"><mat-icon>check</mat-icon>{{ 'benchDetail.saved' | translate }}</span>
      } @else if (noteDirty) {
        <span class="meeting-row__dirty">● {{ 'benchDetail.unsaved' | translate }}</span>
      } @else {
        <span class="meeting-row__hint">
          {{ (hasSavedNote ? 'meetingMode.note.savedHint' : 'meetingMode.note.emptyHint') | translate }}
        </span>
      }
      <button mat-flat-button class="meeting-row__save" [disabled]="!noteDirty || isSaving" (click)="saveNote()">
        {{ 'benchDetail.save' | translate }}
      </button>
    </div>
  </label>

  @if (history.length > 0) {
    <div class="meeting-row__history">
      <div class="meeting-row__history-head">{{ 'meetingMode.note.history' | translate }}</div>
      @for (n of history; track n) {
        <div class="meeting-row__hist-row">
          <span class="meeting-row__hist-date">{{ n.date | date: 'dd.MM.yyyy' }}</span>
          @if (n.author) {
            <span class="meeting-row__hist-autor">{{ n.author }}</span>
          }
          <span class="meeting-row__hist-text">{{ n.text }}</span>
        </div>
      }
    </div>
  }
</div>
